<template>
    <div ref="new_template">
        <ErrorMessages :errors="errors" :description="$t('ui.general.error')" :is_closable="true"></ErrorMessages>
        <div v-if="is_initialized">
            <table class="ui fixed table blue">
                <thead>
                    <tr>
                        <th class="right aligned">
                            <h3 class="ui header">
                                <!-- 新 -->
                                {{ $t('ui.toolbox.crud_templates.new') }}
                                {{ index_item_name }}
                            </h3>
                        </th>
                        <th colspan="4">
                        </th>
                        <th>
                        </th>
                    </tr>
                </thead>
                <tbody class="ui form">
                    <tr v-for="column in columns">
                        <td class="right aligned">
                            {{ column.human_name }}
                        </td>
                        <td colspan="5" style="overflow: visible;">
                            <input type="text" v-model="index_item[column.attribute_name]" :placeholder="column.placeholder" v-if="column.type == 'text'">
                            <input type="number" v-model="index_item[column.attribute_name]" :placeholder="column.placeholder" v-if="column.type == 'number'">
                            <textarea v-model="index_item[column.attribute_name]" :placeholder="column.placeholder" rows="5" v-if="column.type == 'textarea'"></textarea>
                            <select class="ui dropdown" v-dropdown v-model="index_item[column.attribute_name]" v-if="column.type == 'selection'">
                                <option value="">{{ $t('ui.general.please_select') }}</option>
                                <option v-for="option in column.options" :value="option[column.option_attribute_name]">{{ option[column.option_human_name] }}</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td class="right aligned">
                            {{ $t('ui.general.operate') }}
                        </td>
                        <td colspan="5" style="overflow: visible;">
                            <button class="ui basic positive button" @click.prevent="create_index_item">{{ $t('ui.general.create') }}</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import ErrorMessages from '@toolbox/error_box/main.vue'
export default {
    name: "CRUDTemplatesNew",
    props: {
        // form內容
        columns: Array,
        // auth
        authentication_token: String,
        // 對象的human name
        index_item_name: String,
        // response中代表對象的keyname
        api_response_corresponding_name_of_index_item: String,
        // 建立資料url
        create_index_item_url: {
            type: Object,
            default: () => { return {} },
        },
        // 建立完成後重新導向url
        after_create_url: {
            type: Object,
            default: () => { return {} },
        }
    },
    data() {
        return {
            is_initialized: false,
            is_loading: false,
            index_item: {},
            errors: [],
        }
    },
    created() {
    },
    mounted() {
        this.init()
    },
    watch: {
    },
    computed: {
    },
    methods: {
        async init() {
            try {
                await new Promise(resolve => {
                    this.is_initialized = false
                    resolve()
                })
                await new Promise(resolve => {
                    this.is_initialized = true
                    resolve()
                })
            } catch (e) {
                switch (e) {
                    default:
                    console.log("init error: ")
                    console.log(e)
                }
            } finally {
            }
        },
        create_index_item() {
            this.is_loading = true
            this.errors = []
            var params = this.index_item
            var url = this.convert_url_object(this.create_index_item_url)
            return axios.post(url, params, { headers: { Authorization: this.authentication_token }})
                .then(response => {
                    if (response.data.status == "success") {
                        this.index_item = response.data[this.api_response_corresponding_name_of_index_item]
                        // this.$noty.success("建立" + this.index_item_name + "成功")
                        this.$noty.success(
                            this.$t('ui.notifications.success.create__name', {
                                name: this.index_item_name
                            })
                        )
                        this.$router.push(this.convert_url_object(this.after_create_url))
                    } else {
                        return Promise.reject(response.data)
                    }
                })
                .catch(error => {
                    if (error.response) {
                        switch (error.response.status) {
                            default:
                            this.errors.push(error.response.status + ' ' + error.response.statusText)
                        }
                        // this.$noty.error('取得 ' + this.index_item_name + ' 失敗: ' + error.response.status + ' ' + error.response.statusText)
                        this.$noty.error(
                            this.$t('ui.notifications.error.fetch__name', {
                                name: this.index_item_name,
                                reason: ': ' + error.response.status + ' ' + error.response.statusText
                            })
                        )

                    } else if (error.errors) {
                        // this.$noty.error('取得 ' + this.index_item_name + ' 失敗: ' + error.errors)
                        this.$noty.error(
                            this.$t('ui.notifications.error.fetch__name', {
                                name: this.index_item_name,
                                reason: ': ' + error.errors
                            })
                        )

                        this.errors = response.data.errors
                    } else {
                        this.errors.push(this.$t('ui.general.server_offline'))
                        this.$noty.error(this.$t('ui.general.server_offline'))
                    }
                    return Promise.reject(error)
                })
                .finally(() => {
                    setTimeout(() => {
                        this.is_loading = false
                    }, 300)
                })
        },
        convert_url_object(obj) {
            var params_obj = {}
            for (let param of obj.params) {
                switch (param.source) {
                    case "index_item":
                        params_obj[param.key_name] = this.index_item[param.attribute_name]
                        break
                    case "route_params":
                        params_obj[param.key_name] = this.$route.params[param.attribute_name]
                        break
                }
            }
            switch (obj.type) {
                case "vue":
                    return {
                        name: obj.url,
                        params: params_obj,
                    }
                    break
                case "http":
                    return new RestUrl(obj.url).parse(params_obj)
                    break
            }
        },
    },
    components: {
        ErrorMessages,
    }
}
</script>

<style scoped>
</style>
